import React, { useState } from 'react';

function VolumeConverter() {
  const [value, setValue] = useState('');
  const [conversionType, setConversionType] = useState('mlToOz');
  const [result, setResult] = useState('');

  const conversions = [
    { id: 'mlToOz', name: 'Milliliters to Ounces', formula: val => val * 0.033814 },
    { id: 'ozToMl', name: 'Ounces to Milliliters', formula: val => val * 29.5735 },
    { id: 'lToGal', name: 'Liters to Gallons', formula: val => val * 0.264172 },
    { id: 'galToL', name: 'Gallons to Liters', formula: val => val * 3.78541 },
    { id: 'cupToMl', name: 'Cups to Milliliters', formula: val => val * 236.588 },
    { id: 'mlToCup', name: 'Milliliters to Cups', formula: val => val / 236.588 },
    { id: 'pintToL', name: 'Pints to Liters', formula: val => val * 0.473176 },
    { id: 'lToPint', name: 'Liters to Pints', formula: val => val * 2.11338 }
  ];

  const handleConvert = () => {
    if (!value || isNaN(value)) {
      setResult('Please enter a valid number');
      return;
    }

    const conversion = conversions.find(c => c.id === conversionType);
    if (conversion) {
      const convertedValue = conversion.formula(parseFloat(value));
      const fromUnit = conversion.name.split(' to ')[0].toLowerCase();
      const toUnit = conversion.name.split(' to ')[1].toLowerCase();
      setResult(`${value} ${fromUnit} = ${convertedValue.toFixed(2)} ${toUnit}`);
    }
  };

  return (
    <div className="converter">
      <h2>Volume Converter</h2>
      <select value={conversionType} onChange={(e) => setConversionType(e.target.value)}>
        {conversions.map(conversion => (
          <option key={conversion.id} value={conversion.id}>
            {conversion.name}
          </option>
        ))}
      </select>
      <input
        type="number"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={`Enter ${conversions.find(c => c.id === conversionType).name.split(' to ')[0]}`}
      />
      <button onClick={handleConvert}>Convert</button>
      {result && <div className="result">{result}</div>}
    </div>
  );
}

export default VolumeConverter;
